import * as types from '../actions/actionTypes';
import initialState from './initialState';

const _isTpAccount = (accounts, activeAccountId) => {
  const currentAccount = accounts.find(
    account => account.accountId === activeAccountId
  );
  if (currentAccount) {
    return currentAccount.accountType === 'TPP';
  }
  return false;
};

const _isSSOAccount = (accounts, activeAccountId) => {
  return accounts.some(account => account.sso === true);
};
const _getCurrentAccount = accounts => {
  return accounts.map(account => {
    let accountName = account.accountName;
    return {
      ...account,
      accountName,
    };
  });
};

export default (state = initialState.accounts, action) => {
  switch (action.type) {
    case types.GET_ACCOUNTS:
      return {
        ...state,
        accounts: { data: _getCurrentAccount(action.payload) },
        activeAccountId: initialState.activeAccountId,
      };
    case types.SET_ACTIVE_ACCOUNT:
      return {
        ...state,
        accounts: { ...state.accounts },
        activeAccountId: action.accountId,
        isTPAccount: _isTpAccount(state.accounts.data, action.accountId),
        isSSOAccount: _isSSOAccount(state.accounts.data, action.accountId),
        currentAccount: state.accounts.data.find(
          account => account.accountId === action.accountId
        ),
      };
    case types.PREFERED_ACCOUNT_ID:
      return {
        ...state,
        preferredAccountId: action.preferedAccountId
          ? Number(action.preferedAccountId)
          : null,
      };
    default:
      return state;
  }
};
